import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import { launchGameWithMobileOptimization } from '../utils/mobileGameLauncher';

const Home = () => {
  React.useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('.hero-section');
      const heroFeatures = document.querySelectorAll('.hero-feature:nth-child(1) .hero-feature-content h3, .hero-feature:nth-child(2) .hero-feature-content h3, .hero-feature:nth-child(3) .hero-feature-content h3, .hero-feature:nth-child(1) .hero-feature-content p, .hero-feature:nth-child(2) .hero-feature-content p, .hero-feature:nth-child(3) .hero-feature-content p');
      const heroIcons = document.querySelectorAll('.hero-feature-icon svg');
      
      if (heroSection) {
        const heroTop = heroSection.offsetTop;
        const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
        const currentScroll = window.scrollY;
        
        if (currentScroll > heroTop + (heroSection.offsetHeight * 0.2)) {
          // Scrolled past 20% of hero section - make text and icons black
          heroFeatures.forEach(element => {
            element.classList.add('scrolled');
          });
          heroIcons.forEach(icon => {
            icon.style.stroke = '#000000';
          });
        } else {
          // Near top of hero section - make text and icons white
          heroFeatures.forEach(element => {
            element.classList.remove('scrolled');
          });
          heroIcons.forEach(icon => {
            icon.style.stroke = '#ffffff';
          });
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="main-content">
      {/* Background effects */}
      <div className="glow-orb"></div>
      <div className="glow-orb"></div>
      <div className="glow-orb"></div>
      
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-gradient"></div>
          <div className="hero-grid-pattern"></div>
          <div className="hero-orbs">
            <div className="hero-orb hero-orb-1"></div>
            <div className="hero-orb hero-orb-2"></div>
            <div className="hero-orb hero-orb-3"></div>
          </div>
        </div>
        
        <div className="container">
          <div className="hero-content">

            
                         <h1 className="hero-title">
               Crafting Our First
               <br />
               <span className="text-gradient">Wave Defense Game</span>
             </h1>
             

            
            <div className="hero-actions">
                             <button 
                 onClick={(e) => {
                   e.preventDefault();
                   e.stopPropagation();
                   const url = window.location.origin + '/storm-dash-preview/index.html';
                   launchGameWithMobileOptimization(url);
                   return false;
                 }} 
                 className="btn btn-primary hero-cta"
               >
                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                   <polygon points="5,3 19,12 5,21 5,3"/>
                 </svg>
                 Try Preview Build
               </button>
              <Link to="/about" className="btn btn-secondary">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <path d="M12 17h.01"/>
                </svg>
                Learn More
              </Link>
            </div>
          </div>
          
          <div className="hero-showcase">
            <div className="hero-game-preview">
              <div className="game-preview-header">
                <div className="game-preview-controls">
                  <div className="control-dot control-red"></div>
                  <div className="control-dot control-yellow"></div>
                  <div className="control-dot control-green"></div>
                </div>

              </div>
              <div className="game-preview-content">
                <iframe
                  src="https://www.youtube.com/embed/4hzcjFybnRM"
                  title="Storm Dash Gameplay Preview"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="game-preview-video"
                ></iframe>
              </div>
            </div>
            
            <div className="hero-features">
              <div className="hero-feature">
                <div className="hero-feature-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                </div>
                                 <div className="hero-feature-content">
                   <h3>Wave Defense</h3>
                   <p>Survive endless enemy waves</p>
                 </div>
               </div>
               
               <div className="hero-feature">
                 <div className="hero-feature-icon">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                     <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                   </svg>
                 </div>
                 <div className="hero-feature-content">
                   <h3>Your Style</h3>
                   <p>Play the way you want</p>
                 </div>
               </div>
               
               <div className="hero-feature">
                 <div className="hero-feature-icon">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                     <circle cx="12" cy="12" r="10"/>
                     <path d="M8 14s1.5 2 4-2 4-2"/>
                     <line x1="9" y1="9" x2="9.01" y2="9"/>
                     <line x1="15" y1="9" x2="15.01" y2="9"/>
                   </svg>
                 </div>
                 <div className="hero-feature-content">
                   <h3>Abilities</h3>
                   <p>Equip powers to survive</p>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="floating-stars">
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
        </div>
        <div className="floating-teddies">
          <div className="floating-teddy"></div>
          <div className="floating-teddy"></div>
        </div>
        <div className="container">
          <h2 className="section-title">Our Latest Game</h2>
          <p className="section-subtitle" style={{color: '#ffffff'}}>Experience the thrill of Storm Dash</p>
          
          <div className="game-preview">
            <div className="game-info slide-left">
              <h3 style={{color: '#ffffff'}}>Storm Dash</h3>
              <p>A wave defense game where the most important thing is to play in your style. Your goal is to stay alive as long as you can. You can equip many abilities for your character to increase your chances of survival.</p>
              <div className="game-features">
                <div className="feature" style={{"--feature-index": 0}}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                  </svg>
                  <span>Wave defense gameplay</span>
                </div>
                <div className="feature" style={{"--feature-index": 1}}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="8.5" cy="7" r="4"/>
                    <path d="M20 8v6M23 11h-6"/>
                  </svg>
                  <span>Play your style</span>
                </div>
                <div className="feature" style={{"--feature-index": 2}}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                  </svg>
                  <span>Equip abilities</span>
                </div>
                <div className="feature" style={{"--feature-index": 3}}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                  </svg>
                  <span>Survive as long as you can</span>
                </div>
              </div>
              <Link to="/storm-dash" className="btn btn-accent">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 3l14 9-14 9V3z"/>
                </svg>
                Play Now
              </Link>
            </div>
            <div className="game-screenshot slide-right">
              <div className="game-logo-container">
                <img src="/blueteddyfloat.png" alt="Storm Dash Logo" className="storm-dash-logo" />
                <div className="logo-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* No floating support button on the gaming site */}

      <section className="section">
        <div className="floating-stars">
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
          <div className="star"></div>
        </div>
        <div className="container">
          <h2 className="section-title">Stay Connected</h2>
          <p className="section-subtitle">Follow our development journey</p>
          <div className="social-links">
            <a href="https://www.tiktok.com/@falcondevteam" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-.88-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
              <span>TikTok</span>
            </a>
            <a href="https://www.youtube.com/@FalconDevTeam" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
              <span>YouTube</span>
            </a>
            <a href="https://discord.gg/NuB3s65E" target="_blank" rel="noopener noreferrer" className="social-link">
              <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.019 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
              </svg>
              <span>Discord</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
